import { buildBusinessErrorFromError } from '@mgdis/eu-domain';
class JustificationsRestAdapter {
    tenantId;
    restHttpAdapter;
    /**
     * API of justifications.
     */
    constructor({ tenantId, restHttpAdapter }) {
        this.tenantId = tenantId;
        this.restHttpAdapter = restHttpAdapter;
    }
    /**
     * Create justification
     *
     * @returns created justification
     */
    async createJustification(justification) {
        try {
            const res = await this.restHttpAdapter.post(`/referentiel-justification/api/tenants/${this.tenantId}/justifications`, justification);
            return { response: res.data };
        }
        catch (error) {
            return { error: buildBusinessErrorFromError(error) };
        }
    }
}
export { JustificationsRestAdapter };
//# sourceMappingURL=justifications-rest.adapter.js.map